import {
  Button,
  Grid,
  InputLabel,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Rating from '@material-ui/lab/Rating';

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../../../../Components/CustomInput";
import "react-phone-input-2/lib/style.css";
import IconButton from "@material-ui/core/IconButton";

import DataService from "../../../../../../Service";
import CircularIndeterminate from "../../../../../../Components/Loader";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import AddIconBox from "@material-ui/icons/Add";
import CopyToClipboard from "../../../../../../Components/copy_to_clipboard";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";
import ManageEvaluationForm from "../manage_evaluation_form"

const useStyles = makeStyles(() => ({
  labelText: {

  },
}));


function EvaluationForm(props) {


  const classes = useStyles();

  const [currentSelectionField, setCurrentSelectionField] = useState({});
  const [currentSelection, setCurrentSelection] = useState({});
  const [EvaluationForm, setEvaluationForm] = useState([]);
  const [action, setAction] = useState(null);
  const [fieldAction, setFieldAction] = useState(null);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  const [evaluationFormId, setEvaluationFormId] = useState("");
  const [evaluationSlug, setEvaluationSlug] = useState("");



  const getEvaluationForm = () => {
    const params = {
      programme_id: props.programme_id,
    };
    DataService.getDirectData(`/evaluation_forms`, params).then((res) => {
      setTotalCount(res["total_count"]);
      let EvaluationForm = res.evaluation_form.evaluation_form_fields;

      setEvaluationForm(EvaluationForm);
      setEvaluationSlug(res.evaluation_form.slug)
      setLoading(false);
    });
  };

  useEffect(() => {
    setLoading(true);
    getEvaluationForm();
  }, [evaluationFormId, props.organisationId]);
  const handleClose = (data, id) => {
    let moduleList = [];
    if (
      (action === "create" || fieldAction === "createField") &&
      data &&
      data.id
    ) {
      moduleList = [data].concat(modules);
      setModules(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter((base) => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setFieldAction(null);
    setCurrentSelection({});
    setCurrentSelectionField({});
  };

  return (
    <div>
      <Grid
        container
        direction="val"
        alignItems="center"
        style={{
          padding: 30,
          marginBottom: 20,
          backgroundColor: "#F7F7F7",
        }}
      >
        <Grid item xs={12}>
          {/* <CopyToClipboard
                    text={evaluationSlug}
                    formName={'evaluation_form'}
                  />    */}
        </Grid>

        <Grid item xs={12}>
          <React.Fragment>
            <React.Fragment>
              {EvaluationForm.length > 0 &&
                EvaluationForm.map((val, index) => {
                  return (
                    <div className={classes.categoryBox}>
                      <React.Fragment>
                        <React.Fragment>
                          {index === 0 && (
                            <Button
                              variant="contained"
                              style={{ marginLeft: "80%", textTransform: "initial" }}
                              color="primary"
                              onClick={() => {
                                setAction("create");
                                setEvaluationFormId(val.evaluation_form_id);
                              }}
                              startIcon={
                                <AddIconBox size="small" variant="outlined" />
                              }
                            >
                              Add new field
                            </Button>
                          )}
                        </React.Fragment>{" "}
                      </React.Fragment>
                    </div>
                  );
                })}
            </React.Fragment>

            {EvaluationForm.length > 0 &&
              EvaluationForm.map((val, index) => {
                return (
                  <div style={{ marginTop: "40px" }}>
                    <Grid
                      container
                      direction="val"
                      alignItems="flex-start"
                      style={{ marginBottom: 20 }}
                    >
                      <Grid
                        item
                        xs={12
                        }
                      >
                        <InputLabel>
                          <Typography variant="h2" style={{ marginTop: 20, color: "#4D4F5C", }}>
                            {val.question_name}
                          </Typography>
                        </InputLabel>
                      </Grid>
                      {EvaluationForm[index].evaluation_ratings.map((row) => (
                        <React.Fragment>
                          <Grid
                            container
                            direction="val"
                            alignItems="center"
                            style={{ marginBottom: 20 }}
                          >
                            <Grid item xs={4}>
                              <InputLabel>
                                <Typography variant="h2" style={{ marginTop: 20, color: "#4D4F5C", }}>
                                  {row.rating_value}
                                </Typography>
                              </InputLabel>
                            </Grid>
                            <Grid item xs={4}>
                              <Rating name="read-only" value={row.star_number} readOnly />
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      ))}
                      <Grid
                        item
                        style={{
                          paddingTop: "20px"

                        }}
                        xs={
                          9
                        }
                      >
                        <Grid
                          container
                          direction="val"
                          alignItems="center"
                          style={{ marginBottom: 20 }}
                        >
                          <Grid item xs={12}>
                            {(val.question_type === "Q/A" ||
                              val.question_type === "Q/A")
                              &&
                              // val.field_name !== "description" && (
                              <CustomInput
                                disabled
                                multiline
                                rows="4"
                                id="first_name"
                                variant="outlined"

                              />
                              // )
                            }
                            {(val.question_type === "text"
                            )
                              &&
                              <CustomInput
                                disabled

                                id="first_name"
                                variant="outlined"

                              />
                            }
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={2}
                      >
                        <IconButton
                          onClick={() => {
                            setAction("edit");
                            setEvaluationFormId(val.evaluation_form_id);
                            setCurrentSelection(val);
                            setCurrentSelectionField(val);
                          }}
                        >
                          <EditIcon
                            style={{
                              fontSize: 25,
                              marginTop: "-3px",
                            }}
                          />
                        </IconButton>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <IconButton
                          onClick={() => {
                            setAction("delete");
                            setEvaluationFormId(val.evaluation_form_id);
                            setCurrentSelection(val);
                            setCurrentSelectionField(val);
                          }}
                        >
                          <CloseIcon
                            style={{
                              fontSize: 25,
                              marginTop: "-3px",
                            }}
                          />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </div>
                );
              })}
          </React.Fragment>
        </Grid>
      </Grid>

      {loading && <CircularIndeterminate />}

      {(action || fieldAction) && (
        <ManageEvaluationForm
          action={action}
          // fieldAction={fieldAction}
          evaluationFormId={evaluationFormId}
          data={currentSelection}
          data1={currentSelectionField}
          getEvaluationForm={getEvaluationForm}
          handleClose={handleClose}
        />
      )}
    </div>
  );
}

export default EvaluationForm;
